<template>
    <el-table
            :data="computedtickets"
            style="width: 100%"
            :default-sort = "{prop: 'date', order: 'descending'}">
        <el-table-column
                prop="date"
                label="Fecha"
                sortable
                width="100px"

              >
        </el-table-column>
        <el-table-column
                prop="type"
                label="Tipo"
                min-width="150px"
                sortable>
        </el-table-column>
        <el-table-column
                prop="status"
                label="Estado"
                min-width="180px"
                sortable>
        </el-table-column>
        <el-table-column
                prop="link"
                label="Ticket"
                width="80px"
               >
            <template slot-scope="scope">

                <a :href="scope.row.link" target="_blank"><i class="el-icon-link"></i></a>
            </template>
        </el-table-column>
    </el-table>
</template>

<script>
    export default {
        name: "ticketTable",
        props: {
            tickets: {
                type: Array,
                required: true
            }
        },
        computed:{
            computedtickets: function () {
                return this.tickets.map(t => {
                    return {
                        date: new Date(t.timestamp).toISOString().substring(0,10),
                        link: "https://debmedia.freshdesk.com/a/tickets/" + t.id,
                        type: t.type,
                        user: t.user,
                        status: t.status
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
